import { AuthSdkError } from '@okta/okta-auth-js';
import { useOktaAuth } from '@okta/okta-react';

import { PageRoutes } from '@/components/shared/routes';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../providers/AuthContextProvider';
import {
    EVENT_LOG_NAMES,
    getLoggingContext,
    honeybadgerLogEvent,
} from '@/components/shared/utils/logging';
import { normalizeInternalEmail } from '@/components/shared/utils/utils';

export const LoginCallback = () => {
    const navigate = useNavigate();
    const { oktaAuth } = useOktaAuth();
    const { setError } = useAuth();

    useEffect(() => {
        const handleCallback = async () => {
            try {
                await oktaAuth.handleRedirect();

                // Log successful login verification
                const authState = oktaAuth.authStateManager.getAuthState();
                const rawEmail = authState?.idToken?.claims?.email as string | undefined;
                const userEmail = rawEmail ? normalizeInternalEmail(rawEmail) : rawEmail;
                const userId = authState?.idToken?.claims?.sub;

                honeybadgerLogEvent(EVENT_LOG_NAMES.LoginVerifyClick, {
                    level: 'INFO',
                    customAttributes: {
                        ...getLoggingContext(userEmail, userId),
                        timestamp: new Date().toISOString(),
                    },
                });
            } catch (error: unknown) {
                // enable for debugging if you need it
                // console.log('Auth Error: ', JSON.stringify(error));

                if (error instanceof AuthSdkError) {
                    if (
                        window.location.hostname === 'localhost' &&
                        error.errorSummary === 'Unable to parse a token from the url'
                    ) {
                        // let the redirect to root happen. this is a bug with Okta.
                        // TODO: figure out if it's a config issue or SSL thing with http://localhost
                    } else {
                        // some other legit Okta SDK error and it's not localhost
                        setError(error.errorSummary);
                        navigate(PageRoutes.AUTH_ERROR);
                    }
                } else {
                    // not even an SDK error... something else entirely.
                    const err = error as Error & { error_description: string };
                    setError(err?.error_description || err?.message || 'Error');
                    navigate(PageRoutes.AUTH_ERROR);
                }
            }
        };

        handleCallback();
    }, []);

    return <></>;
};
